import * as Sentry from '@sentry/react';
import dayjs from 'dayjs';
import { useEffect } from 'react';
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from 'react-router-dom';

const sentryTracesAndReplaySampleRate = import.meta.env
  .VITE_SENTRY_TRACES_AND_REPLAY_SAMPLE_RATE;

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,

  // Adds request headers and IP for users, for more info visit:
  // https://docs.sentry.io/platforms/javascript/guides/react/configuration/options/#sendDefaultPii
  sendDefaultPii: true,

  integrations: [
    Sentry.reactRouterV6BrowserTracingIntegration({
      useEffect,
      useLocation,
      useNavigationType,
      createRoutesFromChildren,
      matchRoutes,
    }),
    Sentry.replayIntegration(),
    Sentry.extraErrorDataIntegration(),
    Sentry.captureConsoleIntegration(),
    Sentry.httpClientIntegration(),
    Sentry.reportingObserverIntegration(),
  ],

  // Enable logs to be sent to Sentry
  _experiments: { enableLogs: true },

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for tracing.
  // Learn more at
  // https://docs.sentry.io/platforms/javascript/configuration/options/#traces-sample-rate
  tracesSampleRate: Number.parseFloat(sentryTracesAndReplaySampleRate),

  // Set `tracePropagationTargets` to control for which URLs trace propagation should be enabled
  tracePropagationTargets: [/^\//, import.meta.env.VITE_API_HOST],

  // Capture Replay for 10% of all sessions,
  // plus for 100% of sessions with an error
  // Learn more at
  // https://docs.sentry.io/platforms/javascript/session-replay/configuration/#general-integration-configuration
  replaysSessionSampleRate: Number.parseFloat(sentryTracesAndReplaySampleRate),
  replaysOnErrorSampleRate: Number.parseFloat(sentryTracesAndReplaySampleRate),

  ignoreErrors: ['ResizeObserver loop limit exceeded'],
  sampleRate: Number.parseFloat(import.meta.env.VITE_SENTRY_SAMPLE_RATE),
  attachStacktrace: true,
  debug: !import.meta.env.PROD,
  normalizeDepth: 10,
  initialScope: { tags: { system: 'Admin System' } },
  release: `Admin_${dayjs().format('YYYY-MM-DD')}`,
});
